import account from './account/zh-HK.json';
import affiliate from './affiliate/zh-HK.json';
import component from './component/zh-HK.json';
import menus from './menus/zh-HK.json';
import user from './users/zh-HK.json';
import global from './global/zh-HK.json';
import support from './support/zh-HK.json';
import result from './result/zh-HK.json';
import finance from './finance/zh-HK.json';
import region from './region/zh-HK.json';
import request from './request/zh-HK.json';

const titleMenu = Object.entries(menus).reduce((pre: object, [key, value]: [string, string]) => {
  // 添加统一后缀
  return {
    ...pre,
    [`title.${key}`]: `${value} - LightNode`,
  };
}, {});

export default {
  ...account,
  ...affiliate,
  ...component,
  ...menus,
  ...titleMenu,
  ...user,
  ...global,
  ...support,
  ...result,
  ...finance,
  ...region,
  ...request,
};
